import reqwest from 'reqwest';
import application from './application';

import storage from "./storage";
import axios from 'axios'

export default {
    data() {
        return {
            host: application.host,
            imageHost: application.imageHost,
            // appId: application.appId,
            // platform: application.platform,
            // version: application.version
        }
    },
    created() {

    },
    methods: {

        //POST请求
        request(config) {
            // config.data.appId = application.appId;
            // let token_last = storage.getToken() ? storage.getToken() : '';
            // let token = 'Bearer ' + token_last;
            // console.log(token)
            // config.data.platform = application.platform;
            // config.data.version = application.version;
            // config.data.timestamp = Math.round(new Date().getTime());

            let relativeUrl = config.url;
            if (!config.url.startsWith('http')) {
                relativeUrl = config.url;
            } else {
                let arr = relativeUrl.split("//");
                relativeUrl = arr[1].substring(arr[1].indexOf('/'));
            }
            // let signValue = config.data.token + relativeUrl + config.data.appId + config.data.timestamp;
            // config.data.sign = md5(signValue);

            if (!config.url.startsWith('http')) {
                config.url = application.host + config.url;
            }

            reqwest({
                url: config.url,
                type: 'json',
                method: 'POST',
                crossOrigin: true,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    // 'Authorization': token
                },
                data: JSON.stringify(config.data),
                success: (response) => {
                    if (response.code === 10000) {
                        config.success(response);
                    }  else {
                        config.error(response);
                    }
                },
                error: () => {
                    config.error({
                        message: '网络出现问题，请稍后再尝试！'
                    });
                },
                complete: () => {
                    config.complete();
                }
            });
        },
        //GET请求
        requestGet(config) {

            // let token_last = storage.getToken() ? storage.getToken() : '';
            // let token = 'Bearer ' + token_last;


            let relativeUrl = config.url;
            if (!config.url.startsWith('http')) {
                relativeUrl = config.url;
            } else {
                let arr = relativeUrl.split("//");
                relativeUrl = arr[1].substring(arr[1].indexOf('/'));
            }
            // let signValue = config.data.token + relativeUrl + config.data.appId + config.data.timestamp;
            // config.data.sign = md5(signValue);

            if (!config.url.startsWith('http')) {
                config.url = application.host + config.url;
            }
            // console.log(token)
            reqwest({
                url: config.url,
                type: 'json',
                method: 'GET',
                crossOrigin: true,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    // 'Authorization': token
                },
                data: JSON.stringify(config.data),
                success: (response) => {
                    if (response.code === 10000) {
                        config.success(response);
                    }  else {
                        config.error(response);
                    }
                },
                error: () => {
                    config.error({
                        message: '网络出现问题，请稍后再尝试！'
                    });
                },
                complete: () => {
                    config.complete();
                }
            });
        },

        //PUT请求
        requestPut(config) {

            let token_last = storage.getToken() ? storage.getToken() : '';
            let token = 'Bearer ' + token_last;


            let relativeUrl = config.url;
            if (!config.url.startsWith('http')) {
                relativeUrl = config.url;
            } else {
                let arr = relativeUrl.split("//");
                relativeUrl = arr[1].substring(arr[1].indexOf('/'));
            }
            // let signValue = config.data.token + relativeUrl + config.data.appId + config.data.timestamp;
            // config.data.sign = md5(signValue);

            if (!config.url.startsWith('http')) {
                config.url = application.host + config.url;
            }
            // console.log(token)
            reqwest({
                url: config.url,
                type: 'json',
                method: 'PUT',
                crossOrigin: true,
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
                data: JSON.stringify(config.data),
                success: (response) => {
                    if (response.code === 10000) {
                        config.success(response);
                    } else if(response.code === 10010){
                        localStorage.clear();
                        this.$router.replace({path: '/login/index'});
                        this.$router.go(0);
                    } else {
                        config.error(response);
                    }
                },
                error: () => {
                    config.error({
                        message: '网络出现问题，请稍后再尝试！'
                    });
                },
                complete: () => {
                    config.complete();
                }
            });
        },
		//Delete请求
		requestDelete(config) {

			let token_last = storage.getToken() ? storage.getToken() : '';
			let token = 'Bearer ' + token_last;


			let relativeUrl = config.url;
			if (!config.url.startsWith('http')) {
				relativeUrl = config.url;
			} else {
				let arr = relativeUrl.split("//");
				relativeUrl = arr[1].substring(arr[1].indexOf('/'));
			}
			// let signValue = config.data.token + relativeUrl + config.data.appId + config.data.timestamp;
			// config.data.sign = md5(signValue);

			if (!config.url.startsWith('http')) {
				config.url = application.host + config.url;
			}
			// console.log(token)
			reqwest({
				url: config.url,
				type: 'json',
				method: 'DELETE',
				crossOrigin: true,
				headers: {
					'Accept': 'application/json',
					'Content-Type': 'application/json',
                    'Authorization': token
				},
				data: JSON.stringify(config.data),
				success: (response) => {
                    if (response.code === 10000) {
                        config.success(response);
                    } else if(response.code === 10010){
                        localStorage.clear();
                        this.$router.replace({path: '/login/index'});
                        this.$router.go(0);
                    } else {
                        config.error(response);
                    }
				},
				error: () => {
					config.error({
						message: '网络出现问题，请稍后再尝试！'
					});
				},
				complete: () => {
					config.complete();
				}
			});
		},
        requestFile(config) {

            // config.data.appId = application.appId;
            let token_last = storage.getToken() ? storage.getToken() : '';
            let token = 'Bearer ' + token_last;
            // console.log(token)
            // config.data.platform = application.platform;
            // config.data.version = application.version;
            // config.data.timestamp = Math.round(new Date().getTime());

            let relativeUrl = config.url;
            if (!config.url.startsWith('http')) {
                relativeUrl = config.url;
            } else {
                let arr = relativeUrl.split("//");
                relativeUrl = arr[1].substring(arr[1].indexOf('/'));
            }
            let signValue = config.data.token + relativeUrl + config.data.appId + config.data.timestamp;
            // config.data.sign = md5(signValue);

            if (!config.url.startsWith('http')) {
                config.url = application.host + config.url;
            }

            axios({
                url: config.url,
                method: 'POST',
                responseType: 'blob', // 表明返回服务器返回的数据类型
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
                data: JSON.stringify(config.data),
            }).then(res => { // 处理返回的文件流
                config.success(res);

            })
        },
        handleBack: function () {
            this.$router.back(-1);
        },
        formatDate: function (date, fmt) {
            let o = {
                'M+': date.getMonth() + 1, // 月份
                'd+': date.getDate(), // 日
                'h+': date.getHours(), // 小时
                'm+': date.getMinutes(), // 分
                's+': date.getSeconds(), // 秒
                'S': date.getMilliseconds() // 毫秒
            }
            if (/(y+)/.test(fmt)) {
                fmt = fmt.replace(RegExp.$1, (date.getFullYear() + '').substr(4 - RegExp.$1.length))
            }
            for (var k in o) {
                if (new RegExp('(' + k + ')').test(fmt)) {
                    fmt = fmt.replace(RegExp.$1, (RegExp.$1.length === 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k]).length)))
                }
            }
            return fmt
        }



    }
}



// WEBPACK FOOTER //
// ./src/common/mixin.js